import { Auth0Provider } from "@auth0/nextjs-auth0"
import { UserCircleIcon } from "@heroicons/react/24/outline"
import Link from "next/link"
import React from "react"
import LowerMenuItemDetails from "./LowerMenuItemDetails"

interface Props {
    unauthenticated: boolean
}

export default function LowerMenuItem({ unauthenticated }: Props) {
    if (unauthenticated) {
        return (
            <li className="-mx-6 mt-auto">
                <Link
                    href="/register"
                    className="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-white hover:bg-primary-700"
                >
                    <UserCircleIcon className="size-6 shrink-0" aria-hidden="true" />
                    <span className="truncate">Get started</span>
                </Link>
            </li>
        )
    }

    return (
        <li className="-mx-6 mt-auto">
            <a
                href="/account/settings"
                className="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-white hover:bg-primary-700"
            >
                <Auth0Provider>
                    <LowerMenuItemDetails />
                </Auth0Provider>
            </a>
        </li>
    )
}
